import * as types from './types';
import { loading } from 'State/actions';
import _ from 'lodash';
import { POSLetterTypeEnum } from '../../helpers/helpers';

export const fetchInitialData = () => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.LETTERS_LOADING, true));

    try {
      const responseGrades = await MPWWebApi.getGeneric('grade');
      const data = {
        IsPOSLetterHistory: true,
        ProductTemplateTypes: [
          POSLetterTypeEnum.Student,
          POSLetterTypeEnum.Teacher,
          POSLetterTypeEnum.LowBalance,
        ],
      };
      const responseBadEmails = await MPWWebApi.postGenericInsertUpdate(
        'Letter/GetBadEmailLetterHistory',
        data
      );

      dispatch({
        type: types.LETTERS_GET_GRADES,
        payload: _.get(responseGrades, 'data.Data', []),
      });

      dispatch({
        type: types.LETTERS_GET_BAD_EMAILS,
        payload: _.get(responseBadEmails, 'data.Data', []),
      });
    } catch (error) {
      dispatch({
        type: types.LETTERS_ERROR,
        payload: error.response,
      });
    }

    dispatch(loading(types.LETTERS_LOADING, false));
  };
};

export const processLetters = data => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.LETTERS_LOADING, true));

    try {
      await MPWWebApi.postGenericInsertUpdate(
        'Letter/GetBillLowBalanceLetters',
        data
      );

      switch (_.get(data, 'POSletterType', POSLetterTypeEnum.LowBalance)) {
        case POSLetterTypeEnum.Student:
          dispatch({
            type: types.LETTERS_CLEAR_BAD_EMAILS_STUDENT,
            payload: [],
          });
          break;
        case POSLetterTypeEnum.Teacher:
          dispatch({
            type: types.LETTERS_CLEAR_BAD_EMAILS_TEACHER,
            payload: [],
          });
          break;

        default:
          dispatch({
            type: types.LETTERS_CLEAR_BAD_EMAILS_LOWBALANCE,
            payload: [],
          });
          break;
      }
    } catch (error) {
      dispatch({
        type: types.LETTERS_ERROR,
        payload: error.response,
      });
    }

    dispatch(loading(types.LETTERS_LOADING, false));
  };
};

export const clearBadEmails = data => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.LETTERS_LOADING, true));

    try {
      await MPWWebApi.postGenericInsertUpdate(
        'Letter/WriteLetterHistoryNotifiedUserId',
        data
      );

      try {
        switch (_.get(data, 'POSletterType', POSLetterTypeEnum.LowBalance)) {
          case POSLetterTypeEnum.Student:
            dispatch({
              type: types.LETTERS_CLEAR_BAD_EMAILS_STUDENT,
              payload: [],
            });
            break;
          case POSLetterTypeEnum.Teacher:
            dispatch({
              type: types.LETTERS_CLEAR_BAD_EMAILS_TEACHER,
              payload: [],
            });
            break;

          default:
            dispatch({
              type: types.LETTERS_CLEAR_BAD_EMAILS_LOWBALANCE,
              payload: [],
            });
            break;
        }
      } catch (error) {
        dispatch({
          type: types.LETTERS_ERROR,
          payload: error.response.Errors,
        });
      }
    } catch (error) {
      dispatch({
        type: types.LETTERS_ERROR,
        payload: error.response,
      });
    }

    dispatch(loading(types.LETTERS_LOADING, false));
  };
};

export const clearError = () => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch({ type: types.LETTERS_CLEAR_ERROR });
  };
};



// WEBPACK FOOTER //
// ./src/pages/letters/state/letters/actions.js